import GdsClient, { GuestWeddingResponse } from '../../gds-api-client';

const client = new GdsClient();
export const onSave = async (
  rsvpPageHidden: string,
  allowGuestPreview: string,
  isPrivateRsvp: string,
  onSuccess: ((gdsresponse: GuestWeddingResponse) => void) | undefined
): Promise<void> => {
  const attributes = {
    rsvpPageHidden: rsvpPageHidden === 'true',
    allowGuestPreview: allowGuestPreview === 'true',
    isPrivateRsvp: isPrivateRsvp === 'true',
  };

  try {
    const { data } = await client.updateGuestWedding(attributes);

    if (onSuccess) {
      onSuccess(data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
